import React, { Fragment, memo } from 'react'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'
import { customerProductLabels } from 'src/constants/customer-product/constants'
import type { CustomerProduct } from 'src/interfaces/customerProduct'

interface Props {
  isOpen: boolean
  product: CustomerProduct | null
  isSaving: boolean
  onConfirm(): void
  onClose(): void
}

const DeactivateCustomerProductModalComponent = ({
  isOpen,
  product,
  isSaving,
  onConfirm,
  onClose,
}: Props) => {
  const productLabel = product ? customerProductLabels[product.product] : 'this product'

  return (
    <CommonModal
      isOpen={isOpen}
      title={`Deactivate ${productLabel}?`}
      // States what the backend actually does and what the admin will see afterwards. The last
      // clause is the honest rendering of the endpoint returning ongoing rows only — implying
      // a history this API does not expose would be worse than saying there is none.
      text={`This ends the product now. The customer immediately loses access to any feature it unlocks, and the row disappears from this table — the list only shows ongoing products, so there is no record of it here afterwards.`}
      onClose={onClose}
      buttons={
        <Fragment>
          <Button size="small" color="grey" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            color="red"
            loading={isSaving}
            disabled={isSaving}
            onClick={onConfirm}
            data-testid="customer-product-deactivate-confirm-button"
          >
            Deactivate product
          </Button>
        </Fragment>
      }
    />
  )
}

export const DeactivateCustomerProductModal = memo(DeactivateCustomerProductModalComponent)
